<template>
    <div>
        <v-dialog v-model="showCompetitionDialog" max-width="850px">
            <v-card>
                <dialog-header :title="competition.name" :image="imageUrl" @close="showCompetitionDialog = false" />
                <v-row v-if="loading">
                    <div class="d-flex align-center justify-center">
                        <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
                    </div>
                </v-row>
                <v-row v-else no-gutters>
                    <v-col cols="12" md="5">
                        <TeamsportCompetitionInfo :competition="competition" class="ml-4" />
                    </v-col>

                    <v-col cols="12" md="7">
                        <v-list>
                            <v-list-item-group>
                                <game-class-register-row
                                    v-for="gameClass in gameClasses"
                                    :key="gameClass.id"
                                    :gameClass="gameClass"
                                    @buttonClick="handleClick" />
                            </v-list-item-group>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
        <TeamsportBooking v-model="showBookingDialog" :gameClassId="selectedGameClass.id" @close="closeDialog"
            v-if="showBookingDialog">
        </TeamsportBooking>

        <WatchDialog
            v-if="showWatchDialog"
            v-model="showWatchDialog"
            :entity="selectedGameClass"
            :type="'gameclass'"
            :infoComponent="TeamsportCompetitionInfo"
            :infoComponentProps="{ competition: competition }"
            :showSms="showSmsInWatchDialog"
            :showEmail="showEmailInWatchDialog"
            @close="closeDialog" />
    </div>
</template>

<script>
import GameClassRegisterRow from './Teamsport/GameClassRegisterRow.vue';
import TeamsportCompetitionInfo from './TeamsportCompetitionInfo.vue';
import DialogHeader from './DialogHeader.vue';
import TeamsportBooking from '../views/TeamsportBooking.vue';
import WatchDialog from '../views/WatchDialog.vue';
export default {
    name: 'zoezi-teamsport-competition-dialog',
    props: {
        competition: {
            type: Object,
            required: true
        },
        value: {
            type: Boolean
        }
    },

    components: {
        GameClassRegisterRow,
        TeamsportCompetitionInfo,
        DialogHeader,
        TeamsportBooking,
        WatchDialog,
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.showCompetitionDialog = value;
            }
        },
        showCompetitionDialog(value) {
            this.$emit('input', value);
        },
    },

    data() {
        return {
            gameClasses: [],
            selectedGameClass: null,
            showBookingDialog: false,
            showCompetitionDialog: false,
            showWatchDialog: false,
            loading: true,
            TeamsportCompetitionInfo: TeamsportCompetitionInfo,
            automailingList: [],
        };
    },

    computed: {
        imageUrl() {
            if (!this.competition.teamsport?.imagekey) {
                return this.$api.getImageUrl('/assets/img/teamsport.jpg');
            }
            return this.$api.getImageUrl(this.competition.teamsport?.imagekey)
        },
        showSmsInWatchDialog() {
            return this.automailingList?.some(automailing => {
                return ['SMSFirst', 'emailAndSMS', 'SMSOnly', 'emailFirst'].includes(automailing.sendAs);
            });
        },
        showEmailInWatchDialog() {
            return this.automailingList?.some(automailing => {
                return ['emailFirst', 'emailAndSMS', 'emailOnly', 'SMSFirst'].includes(automailing.sendAs);
            });
        }
    },

    created() {
        this.getGameClasses();
        this.unsubscribe = this.$api.subscribe({ type: 'teamsportgameclass', callback: () => { this.getGameClasses() } });
    },

    destroyed() {
        this.unsubscribe?.();
    },

    methods: {
        closeDialog() {
            this.showBookingDialog = false;
            this.showWatchDialog = false;
            this.selectedGameClass = null;
        },
        getGameClasses() {
            this.loading = true;
            this.$api.get('/api/teamsport/gameclass/get_for_memberpage', { competition_id: this.competition.id }).then(response => {
                this.automailingList = response[0]?.automailing_send_as_info;
                this.gameClasses = response;
                this.loading = false;
            });
        },
        handleClick(gameClass) {
            const now = this.$store.state.now30s;
            const registrationStartDate = new Date(gameClass.competition.registrationStartDate);

            const canRegister = (!gameClass.max_number_of_teams || gameClass.spaceLeft) && registrationStartDate < now;

            this.selectedGameClass = gameClass;
            if (canRegister) {
                this.showBookingDialog = true;
            } else {
                this.showWatchDialog = true;
            }
        },
    }
};
</script>
